module.exports = require("ramda/src/T");